/**
 * @desc: 项目打款 API
 * @author: zengtiansheng
 * @update: 2018/3/20
 */
export default {
  invoiceObtainInfo: '/qtbCompanyCenter/invoice/obtain/info', //获取账号的发票信息
  invoiceApplyList: '/qtbCompanyCenter/invoice/project/apply/list', //发票申请列表
  invoiceApplyCancel: '/qtbCompanyCenter/invoice/project/apply/calcel', //作废接口
  noInvoiceApplyList: '/qtbCompanyCenter/invoice/project/not/invoiced/list', //未开票项目列表获取
  invoiceSubmitInfo: '/qtbCompanyCenter/invoice/submit/info', //添加发票信息
  addressList: '/qtbCompanyCenter/invoice/address/list', //获取发票地址信息
  addressDefaut: '/qtbCompanyCenter/invoice/address/defaut', //获取发票默认地址
  addressAdd: '/qtbCompanyCenter/invoice/address/add', //添加发票地址
  addressDel: '/qtbCompanyCenter/invoice/address/delete', //删除发票地址
  addressUpdate: '/qtbCompanyCenter/invoice/address/update', //更新发票地址
  invoiceApply: '/qtbCompanyCenter/invoice/project/apply', //发票申请
  invoiceApplyDetail: '/qtbCompanyCenter/invoice/project/apply/detail', //发票申请详情
  provinceList: '/qtbCompanyCenter/region/province/list', //获取省份列表
  townList: '/qtbCompanyCenter/region/town/list', //获取城市信息
  areaList: '/qtbCompanyCenter/region/area/list' //获取地区信息
}



// WEBPACK FOOTER //
// ./src/views/invoiceApply/API.js